import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const WAREHOUSE_EDIT_FORM_SCHEMA = yup.object().shape({
  name: yup.string().required("Molimo Vas da unesete naziv skladišta"),
});
